import { Scale, Percent, Zap, FileCheck2 } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  {
    icon: Scale,
    title: "Honestly independent",
    desc: "I'm not tied to any bank or lender panel. I'll tell you what's genuinely best for you — even if that's staying exactly where you are.",
  },
  {
    icon: Percent,
    title: "Deals you won't find online",
    desc: "Some of the best rates are broker-only. I've got access to them, and I'll negotiate with lenders on your behalf.",
  },
  {
    icon: Zap,
    title: "Fast when it matters",
    desc: "Found a place you love? I'll usually have your agreement in principle sorted within 24 hours, so you can make an offer with confidence.",
  },
  {
    icon: FileCheck2,
    title: "I do the chasing",
    desc: "Applications, underwriters, valuations, solicitors — I handle the boring bits and keep you posted at every step.",
  },
];

export default function ValueProp() {
  return (
    <section id="advice" data-testid="value-prop-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400/90 mb-5">
                Why Work With Me
              </p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
                Why seeing the whole market matters.
              </h2>
              <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed max-w-md">
                Pop into your bank and they'll only show you their own deals.
                I search the whole market instead — so you can be sure the
                mortgage you pick is genuinely the best one out there for you.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-7">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <div
                data-testid={`value-feature-${i}`}
                className="group flex gap-6 py-8 border-t border-white/10 first:border-t-0 first:pt-0 transition-colors"
              >
                <span className="font-mono text-sm text-amber-400/70 pt-1">
                  0{i + 1}
                </span>
                <div className="shrink-0 h-12 w-12 rounded-2xl bg-[#073B4C] border border-white/10 flex items-center justify-center group-hover:border-amber-400/40 transition-colors duration-300">
                  <f.icon size={20} className="text-amber-400" />
                </div>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-medium text-white">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm sm:text-base text-slate-400 leading-relaxed max-w-lg">
                    {f.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
